const replace = (str, condition, replace) => {
  if(str){
    return String(str).replace(condition, replace)
  }
  return str
}

const trim = str => {
  if(str){
    return String(str).trim()
  }
  return str
}

const StringUtils = {
  replace,
  trim
}

export default StringUtils


// WEBPACK FOOTER //
// ./src/Utils/StringUtils.js